import ClubItemBase from "./club_item_base";
import UserDataManager from "../../../manager/user_manager";
import ModelData, { IUserData } from "../../public/model_data";
import GameUtil from "../../../utility/game_util";
import Utility from "../../../utility/utility";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ClubHallInfo extends ClubItemBase {

    @property(cc.Sprite)
    avatarIcon: cc.Sprite = null;

    @property(cc.Label)
    avatarName: cc.Label = null;

    @property(cc.Label)
    avtarId : cc.Label = null;

    @property(cc.Label)
    clubName : cc.Label = null;

    @property(cc.Sprite)
    clubIcon : cc.Sprite = null;

    @property(cc.Label)
    currency : cc.Label = null;
 
    @property(cc.Label) 
    saveBox : cc.Label = null;

    @property(cc.Button)
    showBoxBtn : cc.Button = null;

    @property(cc.Button)
    hideBoxBtn : cc.Button = null;

    private bankValue : number;
    private chipValue : number;

    private showValue : boolean = false;



    refresh(clubInfo : any){

        let self = this;
        let uid = ModelData.instance.roleData.id

        if (clubInfo.title) {
            this.clubName.string = clubInfo.title;    
        }else{
            cc.error(" clubInfo.title has not exsit")
        }
        

        this.showValue = false;

        if (this.showValue) {            
            this.onHideBox();

        }else{
            this.onShowBox();
        }

        self.getUserData(uid, (data : IUserData) => { 
            
            self.avatarName.string = Utility.strClamp(data.name,10) ;       
            self.avatarIcon.spriteFrame = data.avatarSprite;  
            self.avtarId.string = "ID: " + uid.toString();
        });


        // GameUtil.loadTexture(clubInfo.logo, function (err, texture) {
           
        //     if (texture != null) {
        //         if (!self.isValid) {
        //             cc.warn("loadTexture self.isValid")
        //             return
        //         }
        //         let frame = new cc.SpriteFrame(texture)                                               
        //         frame.setOriginalSize(cc.size(self.clubIcon.node.width,self.clubIcon.node.height));
        //         self.clubIcon.spriteFrame = frame;
        //     }
        // })
 
    }

    updateChip(currency : number ){        

        if (this.showValue) {

            if (currency) {
                this.currency.string = GameUtil.currencyFormatting(currency).toString();    
            }else{
                this.currency.string = "0";
            }
        }

        this.chipValue = currency;
        
    }

    updateSafebox(safeBox : number){

        if (this.showValue) {

            if (safeBox) {
                this.saveBox.string = GameUtil.currencyFormatting(safeBox).toString();    
            }else{
                this.saveBox.string = "0";
            }
        }

        this.bankValue = safeBox;
    }


    onShowBox(){

        this.showValue = false;

        this.saveBox.string = "****";
        this.currency.string = "****";

        this.hideBoxBtn.node.active = true;
        this.showBoxBtn.node.active = false;

    }

    onHideBox(){
        this.showValue = true;

        this.updateSafebox(this.bankValue);    
        this.updateChip(this.chipValue);    

        this.showBoxBtn.node.active = true;
        this.hideBoxBtn.node.active = false;

    }

}
